export const REPOSITORY_SYSTEM_OPTIONS = [
	{ value: 'sharepoint', label: 'SharePoint / Microsoft 365' },
	{ value: 'airtable', label: 'Airtable / Notion / database' },
	{ value: 'plm', label: 'PLM or formulation system' },
	{ value: 'qms', label: 'Quality management system' },
	{ value: 'erp', label: 'ERP (Oracle, SAP, NetSuite, etc.)' },
] as const

export const REPOSITORY_COPY = {
	title: {
		add: 'Add repository',
		edit: 'Edit repository',
	},
	submit: {
		add: 'Add',
		edit: 'Save',
	},
	description:
		'Document the systems and folders where MoCRA-regulated records live so audits move quickly.',
	fields: {
		systemLabel: 'Which system stores these regulated records?',
		locationLabel: 'Where inside that system can an auditor find them?',
	},
	actions: {
		removeRepositoryConfirmTitle: 'Remove this repository?',
		removeRepositoryConfirmDescription:
			'This repository will be removed from the roster. You can add it again later.',
	},
	summary: {
		locationMissing: 'Location details missing.',
	},
}
